module.exports = __webpack_public_path__ + "img/Path 28038.6529745a.png";